const getLanguageModalOpen = (state) => {
  return state?.languageModalOpen;
};

export { getLanguageModalOpen };
